import { Helmet } from "react-helmet-async";
import  envConstants  from "../Constants";

const ThankYou = () => {
    const thankyou = `${envConstants.API_BASE_PUBLIC_URL}assets/images/thank-you.webp`;
    return (
        <div className="text-center">
            <Helmet>
                <title>Thank You - {envConstants.STORE_NAME ? envConstants.STORE_NAME : 'Online Store'}</title>
                <meta name="description" content="order placed successfully" />
                <meta name="author" content={envConstants.STORE_META_AUTHOR ? envConstants.STORE_META_AUTHOR : 'Auto Part Station Store'} />
                <meta name="keywords" content="thank you" />
            </Helmet>
            <img src="/assets/images/thank-you.webp" style={{width: "40%", margin: "20px 0px"}}/>
        </div>
    )
}

export default ThankYou;